define("shared/utils/copy-post-to-profile", ["exports", "later/utils/constants", "later/utils/copy-record"], function (_exports, _constants, _copyRecord) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.copyPostToProfile = copyPostToProfile;
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/constants",0,"later/utils/copy-record"eaimeta@70e063a35619d71f
  const PROFILE_KEYS = {
    instagram: ['collaborators', 'firstComment', 'locationId', 'locationName', 'shareToFeed'],
    twitter: ['clickTracking'],
    pinterest: ['album', 'linkUrl', 'originalLinkUrl', 'clickTracking'],
    facebook: [],
    linkedin: [],
    tiktok: ['allowTiktokComment', 'allowTiktokDuet', 'allowTiktokStitch'],
    youtube: []
  };

  /**
   * Copy a post to a different social profile - does not save.
   * @param args.gram Post record to copy
   * @param args.socialProfile Social profile to copy post to
   * @returns Copied post record
   */
  async function copyPostToProfile(post, targetProfile) {
    let propertyOverrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const copy = (0, _copyRecord.default)(post);
    copy.set('socialProfile', targetProfile);
    copy.set('autoPublish', targetProfile?.defaultAutoPublish && targetProfile?.canSelectAutoPublish);
    Object.entries(propertyOverrides).forEach(_ref => {
      let [key, value] = _ref;
      copy.set(key, value);
    });
    if (targetProfile.profileType) {
      PROFILE_KEYS[targetProfile.profileType]?.forEach(key => {
        copy.set(key, post.get(key));
      });
    }

    // Note: do not copy removed media items
    const filteredPMIs = copy.get('postMediaItems').filter(postMediaItem => {
      return postMediaItem.get('mediaItem').get('id');
    });

    // Note: For Instagram Reel, only copy the first media item
    if (post.isInstagramReel && !targetProfile.isInstagram) {
      const firstPMI = filteredPMIs.firstObject;
      // Note: For Linkedin, Create a clean copy of the first PMI without any thumbnail settings
      if (targetProfile.isLinkedin) {
        const mediaItem = await firstPMI?.mediaItem;
        const cleanPMI = post.createPMIFromMediaItem({
          mediaItem,
          ordering: 0
        });
        copy.set('postMediaItems', [cleanPMI]);
      } else {
        copy.set('postMediaItems', [firstPMI]);
      }
    }
    // Note: For LinkedIn Videos, only copy first PMI when going to platforms other than Instagram/LinkedIn
    else if (post.isLinkedinVideo && !targetProfile.isInstagram && !targetProfile.isLinkedin) {
      copy.set('postMediaItems', [filteredPMIs.firstObject]);
    } else {
      copy.set('postMediaItems', filteredPMIs);
    }

    // Note: treat (and validate) the post as a text post if it has no media items
    if (filteredPMIs.length == 0) {
      copy.set('gramType', 'text');
    }

    // Note: Ensures videos are copied with postType and type properly computed
    if (post.isVideo) {
      if (targetProfile.isYoutube) {
        copy.set('type', _constants.PlatformPostType.YoutubeShort);
        copy.set('postType', _constants.PostType.YoutubeShort);
      } else if (targetProfile.isInstagram) {
        copy.set('type', post.isCarouselPost ? _constants.PlatformPostType.InstagramPost : _constants.PlatformPostType.InstagramReel);
        copy.set('postType', post.isCarouselPost ? _constants.PostType.InstagramFeed : _constants.PostType.Reel);
      } else if (targetProfile.isFacebook) {
        copy.set('type', post.isReel ? _constants.PlatformPostType.FacebookReel : _constants.PlatformPostType.FacebookPost);
        copy.set('postType', _constants.PostType.Reel);
      } else if (targetProfile.isTiktok) {
        copy.set('type', _constants.PlatformPostType.TikTokPost);
        copy.set('postType', _constants.PostType.Standard);
      } else if (targetProfile.isPinterest) {
        copy.set('type', _constants.PlatformPostType.PinterestPost);
        copy.set('postType', _constants.PostType.Standard);
      } else if (targetProfile.isTwitter) {
        copy.set('type', _constants.PlatformPostType.TwitterPost);
        copy.set('postType', _constants.PostType.Standard);
      } else if (targetProfile.isLinkedin) {
        copy.set('type', _constants.PlatformPostType.LinkedinPost);
        copy.set('postType', _constants.PostType.Standard);
      }
    }
    if (targetProfile.isSnapchat) {
      copy.set('type', post.isImage ? _constants.PlatformPostType.SnapchatStory : _constants.PlatformPostType.SnapchatSpotlight);
      copy.set('postType', post.isImage ? _constants.PostType.SnapchatStory : _constants.PostType.Spotlight);
    }
    if (targetProfile.isYoutube) {
      copy.set('type', _constants.PlatformPostType.YoutubeShort);
      copy.set('postType', _constants.PostType.YoutubeShort);
    }
    const shouldCopyHasCustomThumbnail = post.isInstagramReel && targetProfile.isInstagram || post.isLinkedinVideo && (targetProfile.isLinkedin || targetProfile.isInstagram);

    // Note: Ensure custom thumbnail is copied for Instagram Reel and Linkedin Video
    if (shouldCopyHasCustomThumbnail) {
      copy.set('hasCustomThumbnail', post.hasCustomThumbnail);
    }
    const libPost = await post.get('linkinbioPost');
    if (libPost && post.hasExistingLinkinbioPost) {
      copy.affixLinkinbioPost(libPost);
    }
    return copy;
  }
  var _default = _exports.default = copyPostToProfile;
});